import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button } from '@material-ui/core';
import { useState } from 'react';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

DetailKnowledgeGroupActionButton.propTypes = {
    hasEditFieldPermissions: PropTypes.bool,
    hasEditSettingPermissions: PropTypes.bool,
    detailTicket: PropTypes.any,
    userDetail: PropTypes.any,
    setIsOpenDialogConfirmBackToDraft: PropTypes.any,
    isDisableBtnSaveTicket: PropTypes.any,
    submitEditTicket: PropTypes.any,
    setIsShowDialogRestoreTicket: PropTypes.any,
    displayMode: PropTypes.any,
    setDisplayMode: PropTypes.any,
    isEdited: PropTypes.bool,
    cancelEditTicket: PropTypes.any
};

export default function DetailKnowledgeGroupActionButton(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {
        hasEditFieldPermissions,
        hasEditSettingPermissions,
        detailTicket,
        userDetail,
        setIsOpenDialogConfirmBackToDraft,
        isDisableBtnSaveTicket,
        submitEditTicket,
        setIsShowDialogRestoreTicket,
        displayMode,
        setDisplayMode,
        isEdited,
        cancelEditTicket,
        formDetail
    } = props;

    const [displayPopupConfirmCancel, setDisplayPopupConfirmCancel] = useState(false);

    const isDisplayButtonCancelEdit = () => {
        return (
            Utils.isEmptyString(detailTicket?.deletedAt) &&
            displayMode === Constant.DISPLAY_MODE.EDIT
        );
    };

    const isDisplayButtonBackToDraft = () => {
        return (
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            userDetail.id === detailTicket.creator &&
            Utils.isEmptyString(detailTicket?.deletedAt) &&
            formDetail?.definitionVariant !== Constant.FORM_VARIANT.KB_KNOWLEDGE
        );
    };

    const isDisplayButtonSaveEdit = () => {
        return (
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            Utils.isEmptyString(detailTicket?.deletedAt)
        );
    };

    const handleClickBtnCancelEdit = () => {
        if (!isEdited) {
            return setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        }

        setDisplayPopupConfirmCancel(true);
    };

    const handleConfirmCancelEdit = () => {
        setDisplayPopupConfirmCancel(false);
        cancelEditTicket();
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
    };

    const isDisplayButtonRestore = () => {
        return !Utils.isEmptyString(detailTicket?.deletedAt);
    };

    const isDisplayAnyButton =
        isDisplayButtonCancelEdit() ||
        isDisplayButtonBackToDraft() ||
        isDisplayButtonSaveEdit() ||
        isDisplayButtonRestore();

    if (!isDisplayAnyButton) return <></>;

    return (
        (hasEditFieldPermissions || hasEditSettingPermissions) && (
            <div className="btnHead">
                <div className="btnHead-btn">
                    {/* Cancel */}
                    {isDisplayButtonCancelEdit() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            onClick={() => handleClickBtnCancelEdit()}
                        >
                            {trI18n('BUTTON-CANCEL-EDIT')}
                        </Button>
                    )}

                    {/* Back to draft */}
                    {isDisplayButtonBackToDraft() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                            variant="contained"
                            color="primary"
                            onClick={() => setIsOpenDialogConfirmBackToDraft(true)}
                        >
                            {trI18n('BACK_TO_DRAFT')}
                        </Button>
                    )}

                    {/* Save */}
                    {isDisplayButtonSaveEdit() && (
                        <Button
                            className="btn-send btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={e => submitEditTicket()}
                            disabled={isDisableBtnSaveTicket()}
                        >
                            {trI18n('COMBTN011')}
                        </Button>
                    )}
                </div>

                {/* Restore */}
                {isDisplayButtonRestore() && (
                    <div className="btnHead-btn">
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={() => setIsShowDialogRestoreTicket(true)}
                        >
                            {trI18n('RESTORE')}
                        </Button>
                    </div>
                )}

                {/* Popup confirm cancel */}
                <ConfirmDialog
                    isOpen={displayPopupConfirmCancel}
                    msgConfirm={trI18n('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                    textSubmit={trI18n('CM-BUTTON-OK')}
                    okCallBack={e => handleConfirmCancelEdit()}
                    textClose={trI18n('CM-BUTTON-CANCEL')}
                    closeCallBack={() => setDisplayPopupConfirmCancel(false)}
                />
            </div>
        )
    );
}
